import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate, useParams } from 'react-router'
import { CardButton } from '@/components/card-button'
import { PageHeader } from '@/components/commons'
import { ADMIN_MENU_GROUPS } from '@/constants/admin-menu'
import { hasRouteAccess } from '@/constants/permissions'
import { ROUTES } from '@/constants/routes'
import { useAuthStore } from '@/store'

/** Itens de um grupo do menu da Administração (ex.: Cadastros SSMA) */
export const AdministrationGroupPage = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { group: groupId } = useParams<{ group: string }>()
	const user = useAuthStore((s) => s.user)

	const group = ADMIN_MENU_GROUPS.find((candidate) => candidate.id === groupId)
	if (!group) return <Navigate replace to={ROUTES.ADMINISTRATION.INDEX} />

	const items = user
		? group.items.filter((item) =>
				hasRouteAccess(user.role, item.route, user.badge),
			)
		: group.items

	return (
		<div className="px-4 py-6 sm:px-6">
			<PageHeader
				title={t(`administration.groups.${group.id}.title`)}
				description={t(`administration.groups.${group.id}.description`)}
				onBack={() => navigate(ROUTES.ADMINISTRATION.INDEX)}
			/>
			<div className="grid grid-cols-1 items-stretch gap-3 sm:grid-cols-2 lg:grid-cols-3">
				{items.map((item) => (
					<CardButton
						key={item.id}
						icon={<item.icon className="size-5 text-kaefer-medium-grey" />}
						iconBg="bg-kaefer-medium-grey/10"
						borderColor="border-l-kaefer-medium-grey"
						title={t(`administration.options.${item.id}.title`)}
						description={t(`administration.options.${item.id}.description`)}
						onClick={() => navigate(item.route)}
					/>
				))}
			</div>
		</div>
	)
}
